import { render } from "./SupplyDetailsModal.vue?vue&type=template&id=2ec7a517&scoped=true"
import script from "./SupplyDetailsModal.vue?vue&type=script&lang=js"
export * from "./SupplyDetailsModal.vue?vue&type=script&lang=js"

import "./SupplyDetailsModal.vue?vue&type=style&index=0&id=2ec7a517&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-2ec7a517"]])

export default __exports__